import { getAccessTokenFromLocal } from "Services/helpers";
import { API_URL } from "Store/Shared/Middleware/API/Constants";

const useApi = () => {
    return {
        fetch: (path: string) => fetch(`${API_URL}${path}`, {
                headers: {
                    Authorization: `Bearer ${getAccessTokenFromLocal()}`
                }
            })
            .then(r => r.json())
            .then(r => r?.data)
            .catch(console.log)
    }
}

export default useApi;